import styled from 'styled-components'
import DownArrow from "web/assets/images/arrow_bottom_down_downward_navigation_icon.png";

const PageWrapper = styled.div`
  .web-view {
    display: block;
    @media (max-width: 576px) {
      display: none;
    }
  }
  .mobile-view {
    display: none;  
    @media (max-width: 576px) {
      display: block;
    }
  }
`

const InnerHeader = styled.div`
  min-height: 50px;
  display: flex;
  align-items: baseline;
  border-bottom: solid 1px #97979729;
  padding: 15px 0 20px;
  flex-wrap: wrap;
  justify-content: flex-start;

  > div {
    margin-left: 10px;
    min-width: 100px;
  }
  .date {
    display: grid;
    grid-template-columns: auto auto auto auto;
    grid-gap: 10px;
    div {
    }
    @media (max-width: 767px) {
      display: block;
      > div {
        max-width: 250px;
      }
    }
    @media (max-width: 550px) {
      > div {
        max-width: 100%;
      }
    }
  }
  @media (max-width: 767px) {
    display: grid;
    grid-template-columns: 1fr 1fr;
  }
  @media (max-width: 550px) {
    grid-template-columns: 1fr;
    select {
      max-width: 100% !important;
    }
  }
`;

const TableWrapper = styled.div`
  max-width: 1423px;
  margin: 20px auto 0;
  padding: 15px 10px;
  .request-type-class{
    display: flex;
    align-items: center;
    p{
      white-space: nowrap;
      margin-right: 10px;
    }
  }

  > div {
    border-radius: 10px;
    box-shadow: 0 2px 10px 0 rgb(0 0 0 / 16%);
    padding: 15px 28px;
    @media (max-width: 767px) {
      padding: 15px;
      overflow: hidden;
    }
  }
  @media (max-width: 1250px) {
    padding: 15px;
  }
`;

const SelectWrapper = styled.div`
  display: flex;
  justify-content: flex-end;
  flex-direction: column;

  option{
      font-size : 14px !important;
    }

  select,
  input {
    padding: 5px;
    border: solid 1px transparent !important;
    margin: 2px 0;
    font-size: 16px;
    padding: 10px 13px 10px 13px;
    border-radius: 5px;
    background-color: #e8e2e2;
    -webkit-appearance: none;
    -moz-appearance: none;
    appearance: none;
    min-width: 196px;
    ::-webkit-input-placeholder {
      /* Edge */
      color: #656565;
    }

    :-ms-input-placeholder {
      /* Internet Explorer 10-11 */
      color: #656565;
    }

    ::placeholder {
      color: #656565;
    }
  }
  select {
    background-image: url(${DownArrow});
    background-repeat: no-repeat;
    background-position: calc(100% - 10px) 50%;
    padding: 10px 25px 10px 13px;
  }
  label {
    padding: 5px;
    margin: 2px 0 0;
    font-size: 16px;
  }
  *::-webkit-scrollbar-track {
    background: transparent;
  }
  *::-webkit-scrollbar-thumb {
    border-color: none;
  }
  .chartModal {
    max-width: 172px;
    min-width: 0px;
  }
  .basic-multi-select {
    margin: 2px 0;
  }
  .select__value-container {
    input {
      padding: 7px 0;
      min-width: auto;
    }
  }
  .select__value-container {
    max-height: 78.38px;
    overflow: auto;
  }
  /* .react-select-2-input {
    padding: 7px 0;
  } */
  .select__control {
    border: none;
    background-color: #e8e2e2;
  }
  .react-select-2-input {
    padding: 5px 0;
  }
`;

const MobileViewWrapper = styled.div`
  .mobile-accordion {
    margin-bottom: 10px;
    box-shadow: 0px 2px 10px 0px #00000029;
    margin: 5px 15px 15px 15px;
    border-radius: 5px;
  }

  .accordion-header {
    display: grid;
    grid-template-columns: 2fr 0.1fr;
    justify-content: space-between;
    align-items: center;
    padding: 10px 10px 0px 15px;
    cursor: pointer;
  }

  .accordion-header-left {
    display: grid;
    grid-template-columns: 0.68fr 0.8fr;
  }

  .accordion-header-right {
    display: flex;
    align-items: center;
  }

  .accordion-content {
    padding: 10px 0px 15px 15px;
    display: flex;
    flex-direction: column;
  }

  .accordion-column {
    display: flex;
    flex-direction: column;
  }

  .info-header2 {
    display: grid;
    grid-template-columns: 0.6fr 0.8fr;
    margin-bottom: 10px;
  }

  .info-header1 {
    display: grid;
    grid-template-columns: 1fr;
    margin-bottom: 10px;
  }

  .info-header3 {
    display: grid;
    grid-template-columns: 1fr 1fr 1fr;
    margin-bottom: 10px;
  }

  .info {
    margin-bottom: 7px;
    p{
      margin: 3px 0 0 0px;
      font-size: 15px;
      font-family: 'latobold';
    }
    h6{
      font-size: 13px;
      font-family: 'latoregular';
    }
  }
`;
export { PageWrapper, InnerHeader, SelectWrapper, TableWrapper, MobileViewWrapper };